import React, { useEffect } from "react";
import { Row, Col, ListGroup, Offcanvas } from "react-bootstrap";
import { StruSoftLogo } from "../assets/StruSoftLogo";
import { useTranslation } from "react-i18next";
import { closeModal, openModal } from "../features/ui/uiSlice";
import { useDispatch } from "react-redux";
import { useUser } from "../features/user/userSlice";

export interface SXOffCanvasMenuProps {
  handleCloseOffCanvas: () => void;
  showOffCanvas: boolean;
  user: any;
}

export const SXOffCanvasMenu = (props: SXOffCanvasMenuProps) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { getRolesFromToken } = useUser();
  const [roles, setRoles] = React.useState<string[]>([]);

  useEffect(() => {
    const fetchRoles = async () => {
      let a = await getRolesFromToken();
      setRoles(a);
    };
    fetchRoles();
  }, [props.user]);
  return (
    <Offcanvas id="offcanvas-menu" show={props.showOffCanvas} onHide={props.handleCloseOffCanvas} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title style={{ fontSize: 14 }}>
          <Row>
            <Col>
              Developed by
              <StruSoftLogo />
            </Col>

            <Col xs={4} className="text-end">
              <span id="version_number_span">1.23456</span>
            </Col>
          </Row>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <ListGroup className="offcanvas-listgroup">
          <span>
            <ListGroup.Item onClick={() => window.open("https://strusoft.freshdesk.com/", "_blank")}>
              {t("general.contact_support")}
            </ListGroup.Item>
          </span>
          <span>
            <ListGroup.Item onClick={() => window.open("https://portal.onstrusoft.com", "_blank")}>
              StruSoft Portal
            </ListGroup.Item>
            <ListGroup.Item
              onClick={() => {
                //  setShowLegalAndLicensesDialog(true);
              }}
            >
              {t("general.legal_and_licenses")}
            </ListGroup.Item>
            {roles.includes("sales") && (
              <ListGroup.Item
                onClick={() => {
                  //  setShowLegalAndLicensesDialog(true);
                  dispatch(openModal("adminViewModal"));
                }}
              >
                {t("admin_view_.label")}
              </ListGroup.Item>
            )}
          </span>
        </ListGroup>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
